export default __webpack_public_path__ + "static/media/ethereum_white.53edd177.svg";